module.exports = __webpack_public_path__ + "img/05b_Buy_651.4d1cb654.jpg";